import { useTheme } from "@/lib/theme";
import { Toaster as Sonner } from "sonner";
import { useIsMobile } from "@/hooks/use-is-mobile";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();
  const isMobile = useIsMobile();

  // Sonner toasts are too large for phones, so suppress them entirely on mobile.
  if (isMobile) return null;

  // Narrow our wider theme union to sonner's without asserting.
  const resolvedTheme: ToasterProps["theme"] = theme === "dark" || theme === "light" ? theme : "system";

  return (
    <Sonner
      theme={resolvedTheme}
      className='toaster group'
      toastOptions={{
        classNames: {
          toast: "group toast !bg-background !text-foreground !border-border !shadow-lg border",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
